import ModelBase from './base'
import { inputComponentTypes, componentTypes } from '/@/shared/constants'

export default class ModelStorageBrowser extends ModelBase {
  constructor(data) {
    super(data)
  }

  initVariables() {
    super.initVariables()

    this._type = componentTypes.vStorageBrowser
    this._title = 'storage-browser'

    this._showDate = {
      sortorder: 2,
      title: 'show date',
      group: 'style',
      value: true,
      inputComponentType: inputComponentTypes.checkbox,
    }

    this._showSize = {
      sortorder: 3,
      title: 'show size',
      group: 'style',
      value: true,
      inputComponentType: inputComponentTypes.checkbox,
    }

    this._showUpload = {
      sortorder: 4,
      title: 'show upload',
      group: 'style',
      value: true,
      inputComponentType: inputComponentTypes.checkbox,
    }

    this._showDownload = {
      sortorder: 5,
      title: 'allow download',
      group: 'style',
      value: true,
      inputComponentType: inputComponentTypes.checkbox,
    }

    this._showDelete = {
      sortorder: 6,
      title: 'allow delete',
      group: 'style',
      value: true,
      inputComponentType: inputComponentTypes.checkbox,
    }

    this._showRename = {
      sortorder: 7,
      title: 'allow rename',
      group: 'style',
      value: true,
      inputComponentType: inputComponentTypes.checkbox,
    }

    this._downloadLabel = {
      sortorder: 10,
      title: 'download label',
      group: 'style',
      value: 'download',
      inputComponentType: inputComponentTypes.input,
    }

    this._renameLabel = {
      sortorder: 11,
      title: 'rename label',
      group: 'style',
      value: 'rename',
      inputComponentType: inputComponentTypes.input,
    }

    this._deleteLabel = {
      sortorder: 12,
      title: 'delete label',
      group: 'style',
      value: 'delete',
      inputComponentType: inputComponentTypes.input,
    }

    this._actionThreshold = {
      sortorder: 13,
      title: 'visible actions',
      group: 'style',
      value: 2,
      inputComponentType: inputComponentTypes.number,
    }

    this._acceptTypes = {
      sortorder: 8,
      title: 'allowed file types',
      group: 'style',
      value: '',
      placeholder: 'e.g. .json,.xml,image/*',
      inputComponentType: inputComponentTypes.input,
    }

    this._sortBy = {
      sortorder: 9,
      group: 'style',
      title: 'sort by',
      options: [
        { title: 'name', value: 'name' },
        { title: 'size', value: 'size' },
        { title: 'date', value: 'date' },
      ],
      value: 'date',
      inputComponentType: inputComponentTypes.radio,
    }

    this._sortDirection = {
      sortorder: 10,
      group: 'style',
      title: 'sort direction',
      options: [
        { title: 'ascending', value: 'asc' },
        { title: 'descending', value: 'desc' },
      ],
      value: 'desc',
      inputComponentType: inputComponentTypes.radio,
    }

    this._width = {
      sortorder: 1000,
      title: 'width',
      group: 'position',
      value: 400,
      inputComponentType: inputComponentTypes.number,
    }

    this._height = {
      sortorder: 1001,
      title: 'height',
      group: 'position',
      value: 300,
      inputComponentType: inputComponentTypes.number,
    }

    this._actions = {
      sortorder: 1100,
      title: 'actions',
      group: 'actions',
      value: [],
      inputComponentType: inputComponentTypes.actionsList,
    }
  }
}
